import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getCurrentLazyDensity } from 'owa-fabric-densities';
import { changeDensity } from 'owa-fabric-theme';

export default async function initializeDensity() {
    const selectedDensityMode = getUserConfiguration().UserOptions?.DisplayDensityMode;
    const lazyDensity = getCurrentLazyDensity(selectedDensityMode);
    if (lazyDensity) {
        const density = await lazyDensity.import();
        changeDensity(density);
    }
}
